import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Incasso } from '../../../models/incasso';

@Component({
    selector: '[add_doc_to_incasso]',
  templateUrl: 'add-to-incasso.component.html',
})

export class AddDocumentoToIncassoComponent {
  @Input()
  incasso: Incasso;
  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(incasso: Incasso) {
    this.onClickAddToEntity.emit(incasso);
  }
}
